<div class="pr">
    <div class='block bold'>
        <div class="left">
            <div class="left">Show by:</div>
            <div class="left" style="margin-left: 10px">
                <irb-dropdown-filter #groupDropdown (search)="getItemsForGroup($event)" [(value)]="groupOption" (selection)="setGroup()" size="14"></irb-dropdown-filter>
            </div>
            <br class="clear"/>
        </div>
        <div class="left" style="margin-left: 30px" *ngIf="data.isAllocationGroupEquivalentsRecordsPresent && pralloc.group === 'ungroupedAllocLabel'">Group equivalents: <input type="checkbox" [(ngModel)]="pralloc.showEquivalents" (change)="setShowEquivalents()"/></div>
        <div class="left" style="margin-left: 30px" *ngIf="data.isAllocationExcludedPositionRecordsPresent">Show excluded: <input type="checkbox" [(ngModel)]="pralloc.showExcluded" (change)="setShowExcluded()"/></div>
        <div class="left" style="margin-left: 30px">Display:
            <a *ngIf="columnMode !== 'secDolrVariance'" (click)="setColumnMode('secDolrVariance')">$</a><span *ngIf="columnMode === 'secDolrVariance'">$</span> |
            <a *ngIf="columnMode !== 'secRelVariance'" (click)="setColumnMode('secRelVariance')">Rel %</a><span *ngIf="columnMode === 'secRelVariance'">Rel %</span> |
            <a *ngIf="columnMode !== 'secAbsVariance'" (click)="setColumnMode('secAbsVariance')">Abs %</a><span *ngIf="columnMode === 'secAbsVariance'">Abs %</span>
        </div>
        <div class="right" style="margin-right:30px;font-weight:normal">Show model used in rebalance: <a (click)="showModelHistoryInRebalance()">{{data.historyModelName}}</a></div>
        <br class="clear"/>
    </div>
    <div class="pr-grid right" style="width: 100%;">
        <irb-inventory-grid *ngIf="!isUnitTest"
            [style.width] = "'100%'"
            [style.height] = "gridHeight"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions"
            [domLayout]="domLayout"
            [componentName]="componentName"
            [frameworkComponents] = 'frameworkComponents'
            [rowData] = 'data.pfSecRebalDTOList'
            (gridReady) = "onGridReady($event)"
            autoColumnId = "ALLOCATION"
            [popupParent]="popupParent"></irb-inventory-grid>
        <div>
            <div class="ag-primary-cols-reset-header-panel" (click)="resetGridColumns()">
                <div class="resetIcon"></div>
                <div class="resetText">Reset columns</div>
            </div>
        </div>
    </div>

    <div>
        <div class="left">
            <div class="note hblock" *ngIf="data.isAllocationGroupEquivalentsRecordsPresent && pralloc.group === 'ungroupedAllocLabel'"><i>Split</i> indicates an equivalent allocated to multiple parents.</div>
            <div class="note hblock" *ngIf="data.isAllocationExcludedPositionRecordsPresent">** Equivalent information is not shown for unheld security purchases.</div>
        </div>
        <br class="clear"/>
    </div>
    <irb-common-dialog #dialogPrComAlloc></irb-common-dialog>
</div>

<ng-template #comPrAllocationTemplate>
    <span [innerHTML]="comPrAllocationTemplateContent"></span>
</ng-template>
<ng-template #securityTradeActionNoteTemplate>
    <span [innerHTML]="securityTradeActionNoteTemplateContent"></span>
</ng-template>
